/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsParticipantHadConversationOpen
 */
export interface WsParticipantHadConversationOpen {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsParticipantHadConversationOpen
     */
    type: string | null;
    /**
     * Participant ID
     * @type {string}
     * @memberof WsParticipantHadConversationOpen
     */
    participantId: string;
    /**
     * Conversation ID
     * @type {string}
     * @memberof WsParticipantHadConversationOpen
     */
    conversationId: string;
    /**
     * The participant had the conversation open at this time
     * @type {Date}
     * @memberof WsParticipantHadConversationOpen
     */
    hadConversationOpenAt: Date;
}

/**
 * Check if a given object implements the WsParticipantHadConversationOpen interface.
 */
export function instanceOfWsParticipantHadConversationOpen(value: object): value is WsParticipantHadConversationOpen {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('hadConversationOpenAt' in value) || value['hadConversationOpenAt'] === undefined) return false;
    return true;
}

export function WsParticipantHadConversationOpenFromJSON(json: any): WsParticipantHadConversationOpen {
    return WsParticipantHadConversationOpenFromJSONTyped(json, false);
}

export function WsParticipantHadConversationOpenFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsParticipantHadConversationOpen {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'participantId': json['participant_id'],
        'conversationId': json['conversation_id'],
        'hadConversationOpenAt': (new Date(json['had_conversation_open_at'])),
    };
}

export function WsParticipantHadConversationOpenToJSON(json: any): WsParticipantHadConversationOpen {
    return WsParticipantHadConversationOpenToJSONTyped(json, false);
}

export function WsParticipantHadConversationOpenToJSONTyped(value?: WsParticipantHadConversationOpen | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'participant_id': value['participantId'],
        'conversation_id': value['conversationId'],
        'had_conversation_open_at': ((value['hadConversationOpenAt']).toISOString()),
    };
}

